import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "list-view" }
const _hoisted_2 = { class: "item__title" }
const _hoisted_3 = { class: "item__title--dimension" }
const _hoisted_4 = { class: "item__title--name" }
const _hoisted_5 = { class: "item__metric-type" }
const _hoisted_6 = { class: "item__table base-table-wrapper" }

import { storeToRefs } from 'pinia';
import { useInventoryDashboardStore } from '../pages/useInventoryDashboardStore';
import { InventoryDashboardViewModel } from '../pages/inventoryDashboardViewModel';
import { i18n } from '@/i18n';
import { UNASSIGNED_COLUMN } from '@/coreDomainsModule/constants';
import { computed, provide, ref } from 'vue';
import { DashboardService } from '../domains/services/DashboardService';
import { isTableType } from '@/coreDomainsModule/table';
import { useTableHeader } from '@/corePagesModule/composables/useTableHeader';
import ListViewSectionTable from './ListViewSectionTable.vue';
import { useColumnWidth } from '@/corePagesModule/composables/useColumnWidth';
import {
  LIST_VIEW_AGG_BASE_HEADER_KEYS,
  LIST_VIEW_BASE_HEADER_KEYS,
  LIST_VIEW_BIZ_BASE_HEADER_KEYS,
  LIST_VIEW_CUSTOM_HEADER_KEYS,
  LIST_VIEW_SECTION_INJECTION_KEY,
} from '../constants';

export default /*@__PURE__*/_defineComponent({
  __name: 'ListViewSection',
  setup(__props) {

const t = i18n.t;

const store = useInventoryDashboardStore();
const { state } = storeToRefs(store);
const {} = store;
const vm = new InventoryDashboardViewModel();

const tableWidthInfo = ref<Record<string, number | undefined>>({});

const isAggregateBusiness = computed(() => DashboardService.isMetricTypeByAggBiz(state.value.information.metricType));
const fullHeaderOptions = computed(() => [
  ...LIST_VIEW_BASE_HEADER_KEYS,
  ...(isAggregateBusiness.value ? LIST_VIEW_AGG_BASE_HEADER_KEYS : LIST_VIEW_BIZ_BASE_HEADER_KEYS),
  ...LIST_VIEW_CUSTOM_HEADER_KEYS[state.value.information.metricType],
  { key: 'headerModify', width: 57 },
]);
const fullHeaderKeys = computed(() => fullHeaderOptions.value.map((h) => h.key));
const tableType = computed(() => {
  const rawTableType =
    'inventoryDashboardByDimension' +
    state.value.information.metricType
      .toLowerCase()
      .split('_')
      .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
      .join('');

  if (!isTableType(rawTableType)) {
    console.error(`Invalid table type: ${rawTableType}`);
    throw new Error(`Invalid table type: ${rawTableType}`);
  }
  return rawTableType;
});

const { headerList, updateDisplayHeader } = useTableHeader(fullHeaderKeys, tableType, []);
useColumnWidth({
  tableType: tableType,
  widthInfo: tableWidthInfo,
});

/**
 * チェックされたかどうか
 * @param businessId - 対象の取引ID
 * @param isChecked - チェック済みかどうか
 */
const onCheckedRow = (businessId: string, isChecked: boolean) => {
  if (isChecked && !state.value.checkedBusinessId.includes(businessId)) {
    state.value.checkedBusinessId.push(businessId);
  } else if (!isChecked && state.value.checkedBusinessId.includes(businessId)) {
    state.value.checkedBusinessId = state.value.checkedBusinessId.filter((b) => b !== businessId);
  }
};

/**
 * ヘッダーを切り替える処理
 * @param headerKey - ヘッダーキー
 * @param isHide - 隠すかどうか
 */
const onToggleHeader = async (headerKey: string, isHide: boolean) => {
  await updateDisplayHeader(headerKey, isHide);
};

provide(LIST_VIEW_SECTION_INJECTION_KEY, tableWidthInfo);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).information.dimensionValueGroups, (dimensionValueGroup, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "item"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)(_unref(vm).dimensionTypesMapper[_unref(state).information.dimensionType] ?? '')), 1),
          _createElementVNode("div", _hoisted_4, [
            (
              dimensionValueGroup.dimensionValues.name ||
              dimensionValueGroup.dimensionValues.value ||
              dimensionValueGroup.dimensionValues.unit
            )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(dimensionValueGroup.dimensionValues.name) + " " + _toDisplayString(dimensionValueGroup.dimensionValues.value) + " " + _toDisplayString(dimensionValueGroup.dimensionValues.unit), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_unref(t)(_unref(UNASSIGNED_COLUMN))), 1)
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)(_unref(vm).metricTypesMapper[_unref(state).information.metricType] ?? '')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(ListViewSectionTable, {
            businesses: dimensionValueGroup.businesses,
            "checked-business-id": _unref(state).checkedBusinessId,
            "table-type": tableType.value,
            "full-header-options": fullHeaderOptions.value,
            "header-list": _unref(headerList),
            "is-aggregate-business": isAggregateBusiness.value,
            onOnToggleHeader: onToggleHeader,
            onOnCheckedRow: onCheckedRow
          }, null, 8, ["businesses", "checked-business-id", "table-type", "full-header-options", "header-list", "is-aggregate-business"])
        ])
      ]))
    }), 128))
  ]))
}
}

})